import querystring from 'querystring'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import log from 'blazar-sentry'
import { actionCreators as apiActionCreators } from 'reduxBits/api'
import { numberGroup } from 'utils/format'
import { actionCreators as notificationActions } from 'reduxBits/notifications'

export const REQUEST_SENDMAIL = 'Sending a post request to sendmail'
export const RECEIVE_SENDMAIL = 'Update the state with the results of the request to sendmail'
export const UPDATE_FORM_DATA = 'Update adreply form data'
export const UPDATE_FORM_ERRORS = 'Update adreply form with errors from sendmail api'
export const UPDATE_FORM_SUCCESS = 'Update wether the last submission was successful'
export const REMOVE_FORM_ERROR_MESSAGES = 'Remove all the error messages in the form'
export const HAS_MESSAGE_BEEN_SENT = 'Defines if message has been sent'
export const CLOSED_AD_REPLY = 'Close ad reply page'
export const OPENED_AD_REPLY = 'Opened ad reply'

const openedAdReply = createAction(OPENED_AD_REPLY)

const requestSendmail = createAction(REQUEST_SENDMAIL)
const receiveSendmail = createAction(RECEIVE_SENDMAIL)
const updateFormData = createAction(UPDATE_FORM_DATA)
const updateFormErrors = createAction(UPDATE_FORM_ERRORS)
const updateFormSuccess = createAction(UPDATE_FORM_SUCCESS)
const removeFormErrorMessages = createAction(REMOVE_FORM_ERROR_MESSAGES)
const isSent = createAction(HAS_MESSAGE_BEEN_SENT)

const closedAdReply = createAction(CLOSED_AD_REPLY)

const generateTradeInBody = (regNumber, mileage) => {
  return `\n\nJag är intresserad av inbyte.\n- Reg.nr: ${regNumber}\n- Miltal: ${mileage}`
}

const backToAd = () => async (dispatch) => {
  await dispatch(closedAdReply())
}

const openAdReply = () => async (dispatch) => {
  await dispatch(openedAdReply())
}

const generateFinanceWidgetBody = (widgetSettings, financeData, adPrice) => {
  const options = {
    ...widgetSettings,
    ...financeData,
    adPrice,
    salvageValue: (widgetSettings.salvageValue / 100) * adPrice,
  }

  /* const initialBody = '\n\nAvsändaren är intresserad av finansieringsalternativ.
  \n\nBifogat finansförslag från Blocket:\n' */
  const initialBody = '\n\nBifogat finansförslag från Blocket:\n'
  const dispatcher = {
    companyNameFull: (value) => `Finansföretag: ${value}`,
    monthlyPrice: (value) => `Månadskostnad: ${numberGroup(value)} kr/mån`,
    cash: (value) => `Kontantinsats: ${numberGroup(value)} kr`,
    months: (value) => `Lånetid: ${value} mån`,
    totalCost: (value) => `Lånebelopp: ${numberGroup(value)} kr`,
    effectiveRate: (value) => `Effektiv ränta: ${value.toString().replace('.', ',')} %`,
    rate: (value) => `Ränta: ${value.toString().replace('.', ',')} %`,
    salvageValue: (value) => `Restskuld: ${numberGroup(value)} kr`,
  }
  const financeWidgetBody = Object.keys(dispatcher)
    .map((k) => ({ prop: k, value: options[k] }))
    .reduce((a, b) => {
      a = a
        .concat('- ')
        .concat(dispatcher[b.prop](b.value))
        .concat('\n')
      return a
    }, initialBody)

  return financeWidgetBody
}

function send(adId) {
  return (dispatch, getState) => {
    dispatch(requestSendmail())
    const { sendmail, motor, classified } = getState()
    const { adReplyOptions, financeWidgetSettings, financeData } = motor

    const content = _.mapValues(sendmail.adReplyForm.data, 'value')
    const tradeInBody = adReplyOptions.tradeIn.checked
      ? generateTradeInBody(
          getState().motor.adReplyOptions.tradeIn.regNumber,
          getState().motor.adReplyOptions.tradeIn.mileage,
        )
      : ''
    const financeWidgetBody = adReplyOptions.finance
      ? generateFinanceWidgetBody(
          financeWidgetSettings,
          financeData.data,
          classified.requestedAd.ad.price.value,
        )
      : ''

    content.id = adId
    content.adreply_body = content.body + tradeInBody + financeWidgetBody
    delete content.body

    dispatch(
      apiActionCreators.templateApiFetch(
        'sendmail.json',
        {
          method: 'POST',
          body: querystring.stringify(content),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        },
        'spid',
      ),
    )
      .then((response) => {
        dispatch(receiveSendmail(response))
        dispatch(updateFormSuccess(true))
        // Delay closing the modal so that the user has time to see "Skickat!" (message sent)
        // So in this case debounce is just used to delay
        _.debounce(() => {
          dispatch(isSent(true))
          dispatch(updateFormSuccess(false))
        }, 1000)()
      })
      .catch((error) => {
        log.error(error)
        const response = _.mapKeys(error.content, (value, key) => {
          if (key === 'errAdreplyBody') {
            return 'body'
          }
          return _.lowerFirst(key.replace(/^err/, ''))
        })
        dispatch(receiveSendmail(error))
        dispatch(updateFormErrors({ json: response }))
        dispatch(notificationActions.addErrorNotification(error.content.errAdreplyBody))
      })
  }
}

export const actionCreators = {
  send,
  isSent,
  backToAd,
  updateFormData,
  removeFormErrorMessages,
  openAdReply,
}
